/* ============================================================
   CATERPY JOURNAL - タブフィルタ
   ============================================================
   - タブ切替時に該当タグの記事のみ表示
   - 表示中の先頭カードに featured クラスを付与
   ============================================================ */

(function () {
  'use strict';

  var FEATURED_CLASS = 'caterpy-journal-card--featured';
  var HIDDEN_CLASS   = 'is-hidden';

  document.querySelectorAll('.caterpy-journal').forEach(function (section) {
    var tabs  = section.querySelectorAll('.caterpy-journal__tab');
    var cards = Array.prototype.slice.call(
      section.querySelectorAll('.caterpy-journal-card')
    );
    var grid    = section.querySelector('.caterpy-journal__grid');
    var prevBtn = section.querySelector('.caterpy-journal__arrow--prev');
    var nextBtn = section.querySelector('.caterpy-journal__arrow--next');

    if (tabs.length === 0 || cards.length === 0) return;

    /* --- 矢印ボタンでのスクロール --- */
    function scrollByCard(direction) {
      if (!grid) return;
      var firstVisible = cards.filter(function (c) {
        return !c.classList.contains(HIDDEN_CLASS);
      })[0];
      var step = firstVisible ? firstVisible.getBoundingClientRect().width + 24 : 300;
      grid.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    function updateArrowState() {
      if (!grid || !prevBtn || !nextBtn) return;
      var maxScroll = grid.scrollWidth - grid.clientWidth - 2;
      prevBtn.disabled = grid.scrollLeft <= 0;
      nextBtn.disabled = grid.scrollLeft >= maxScroll;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
    if (grid) {
      grid.addEventListener('scroll', updateArrowState);
      window.addEventListener('resize', updateArrowState);
    }

    /* --- featured クラスを先頭の表示カードに付け替える --- */
    function updateFeatured() {
      cards.forEach(function (card) {
        card.classList.remove(FEATURED_CLASS);
      });

      for (var i = 0; i < cards.length; i++) {
        if (!cards[i].classList.contains(HIDDEN_CLASS)) {
          cards[i].classList.add(FEATURED_CLASS);
          break;
        }
      }
    }

    /* --- タブクリック --- */
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var filter = (tab.getAttribute('data-tab-filter') || '').toLowerCase();

        /* タブ状態の更新 */
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        /* カードのフィルタリング */
        cards.forEach(function (card) {
          if (filter === 'all') {
            card.classList.remove(HIDDEN_CLASS);
            return;
          }
          var tags    = (card.getAttribute('data-article-tags') || '').toLowerCase();
          var tagList = tags.split('|').map(function (t) { return t.trim(); });

          if (tagList.indexOf(filter.trim()) !== -1) {
            card.classList.remove(HIDDEN_CLASS);
          } else {
            card.classList.add(HIDDEN_CLASS);
          }
        });

        /* featured を再割り当て */
        updateFeatured();

        /* 表示切替後はグリッドを先頭に戻す */
        if (grid) grid.scrollTo({ left: 0, behavior: 'auto' });
        updateArrowState();
      });
    });

    /* --- 初期表示時に先頭カードを featured に --- */
    updateFeatured();
    updateArrowState();
  });
})();
